import React, { useState, useCallback } from "react";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import IncidentCreateModal from "Projects/CC_cubi_clan_project/GlobalComponents/IncidentCreateModal/IncidentCreateModal";
import "./IncidentLauncherButton.css";

export default function IncidentLauncherButton({
  appCode = "GEN",
  visible = true,
  label = "Abrir incidencia",
  floatingClassName = "inci-launcher-left",
  buttonColor = "danger",
  iconOnly = false,
  onCreated,
}) {
  const [open, setOpen] = useState(false);
  const handleClose = useCallback(() => setOpen(false), []);

  if (!visible) return null;

  return (
    <>
      <div className={`inci-launcher-wrap ${floatingClassName}`}>
        {iconOnly ? (
          <button
            className="inci-launcher-icon-btn"
            title={label}
            onClick={() => setOpen(true)}
          >
            <MDBIcon fas icon="life-ring" />
          </button>
        ) : (
          <MDBBtn color={buttonColor} className="inci-launcher-btn" onClick={() => setOpen(true)}>
            <MDBIcon fas icon="life-ring" className="me-2" />
            {label}
          </MDBBtn>
        )}
      </div>

      <IncidentCreateModal
        show={open}
        onClose={handleClose}
        appCode={appCode}
        onCreated={onCreated}
      />
    </>
  );
}
